import { render, staticRenderFns } from "./menuTree.vue?vue&type=template&id=aab8adec&scoped=true"
import script from "./menuTree.vue?vue&type=script&lang=js"
export * from "./menuTree.vue?vue&type=script&lang=js"
import style0 from "./menuTree.vue?vue&type=style&index=0&id=aab8adec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab8adec",
  null
  
)

export default component.exports